<div class="modal-header">
  <h2
    class="modal-title"
    [ngClass]="{
      'alert alert-danger p-2 w-100': saleItemsOnBulkActions ? true : null
    }"
  >
    {{ title | translate }}
  </h2>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <sale-item-form
    *ngIf="saleItem || saleItemsOnBulkActions"
    [saleItem]="
      saleItem
        ? saleItem
        : saleItemsOnBulkActions
        ? saleItemsOnBulkActions[0]
        : null
    "
    [saleItemsOnBulkActions]="saleItemsOnBulkActions"
    (onSubmit)="onSubmit($event)"
    (onSubmitBulk)="onSubmitBulk($event)"
    (onBulkEditFieldsChanges)="onBulkEditFieldsChanges($event)"
    (onSubmitDelete)="onSubmitDelete($event)"
    (haveVisibleFather)="isFatherVisible($event)"
    (closeBulkModal)="cancel()"
    [isSalePaid]="isSalePaid$ | async"
  ></sale-item-form>
</div>
